import {createTheme} from "@mui/material";

//********************************************************************************
//* THEME
//********************************************************************************

const themeOptions = {
	  palette: {
			 mode: "dark",
			 primary: {
					main: "#b71c1c",
					light: "#b71c1c",
					dark: "#b71c1c"
			 },
			 secondary: {
					main: "#f50057"
			 },
			 background: {
					default: "#000000",
					paper: "#000000"
			 },
			 text: {
					primary: "rgba(255,255,255,0.9)",
					secondary: "rgba(255,255,255,0.75)",
					disabled: "rgba(255,255,255,0.5)",
					hint: "#bdbdbd"
			 },
			 divider: "rgba(255,255,255,0.5)"
	  },
	  typography: {
			 fontSize: 12,
			 fontWeightLight: 700,
			 fontWeightRegular: 700,
			 fontWeightMedium: 800,
			 fontWeightBold: 900
	  },
	  shape: {
			 borderRadius: 8
	  }
};

const APXTheme = createTheme(themeOptions); /* CREATE THE THEME */

export default APXTheme;


//********************************************************************************
//* COLOURS
//********************************************************************************


export const red_900 = "#b71c1c";
export const error_red = "#FF0000";
export const white = "#FFFFFF";
export const grey_light = "#C8C8C8";
export const grey_medium = "#757575";
export const grey_dark = "#252525";
export const black = "#000000";
export const eatery = "#FFBB00";
export const shop = "#00BBFF";
export const transport = "#009900";
export const photography = "#FF6600";
export const food_veg = "#006000";
export const food_non_veg = "#600000";
export const expense_red_600 = "#B32D2D";
export const expense_green_600 = "#208028";
